import { catchError, from, map, Observable, of } from 'rxjs';
import { apiHelpers } from './helpers';
import { EnvLoader } from './loader';

export class ApiUrlLoader implements EnvLoader {
  constructor(private envService: any) {}
  private initEnvPromise?: Promise<any>;

  private resolveApiUrl(backendUrl: any): string {
    if (backendUrl == null) {
      return '';
    }

    if (typeof backendUrl === 'string') {
      return backendUrl;
    }

    return apiHelpers.getApiUrlByDomain(backendUrl);
  }

  private ensureEnvironment(): Promise<any> {
    if (this.envService?.environment) {
      return Promise.resolve(this.envService.environment);
    }

    if (typeof this.envService?.initEnv === 'function') {
      if (!this.initEnvPromise) {
        this.initEnvPromise = Promise.resolve(this.envService.initEnv()).finally(() => {
          this.initEnvPromise = undefined;
        });
      }

      return this.initEnvPromise.then(() => this.envService?.environment);
    }

    return Promise.resolve(undefined);
  }

  /**
   * Gets the API url from env file
   */
  public getApiUrl(): Observable<string> {
    const backendUrl = this.envService?.environment?.backend_url;

    if (backendUrl != null) {
      return of(this.resolveApiUrl(backendUrl));
    }

    return from(this.ensureEnvironment()).pipe(
      map((environment) => this.resolveApiUrl(environment?.backend_url)),
      catchError(() => of('')),
    );
  }
}
